/*
 * COLESICE – TikTok in-app browsing mode
 * ---------------------------------------------------------------------------
 * TikTok's in-app browser only allows the FIRST page that was opened from TikTok.
 * Every later full page load (product, collection, checkout...) is replaced by
 * "Open this link in your browser". This script is active ONLY inside the TikTok
 * app (or with ?tt_inapp=1 for testing) and:
 *   1. loads other store pages INSIDE the already-open page (no new page load),
 *   2. at checkout, explains how to finish in the phone's browser and turns the
 *      address bar into a cart link, so "••• → Open in browser" lands in checkout
 *      with the same items.
 * It never redirects anyone and does nothing for normal visitors.
 * Turn off testing mode with ?tt_inapp=0.
 */
(function () {
  'use strict';

  var UA = navigator.userAgent || '';
  var forced = false;
  try {
    var qs = new URLSearchParams(location.search);
    if (qs.get('tt_inapp') === '1') sessionStorage.setItem('tt_inapp', '1');
    if (qs.get('tt_inapp') === '0') sessionStorage.removeItem('tt_inapp');
    forced = sessionStorage.getItem('tt_inapp') === '1';
  } catch (e) {}

  var isTikTok = /musical_ly|BytedanceWebview|Bytedance|ByteLocale|TikTok/i.test(UA);
  if (!isTikTok && !forced) return;
  if (window.__ttInappLoaded) return;
  window.__ttInappLoaded = true;

  document.documentElement.classList.add('tt-inapp');

  /* ---------- styles ---------- */
  var css = [
    /* express/dynamic checkout buttons open pop-ups/new pages that TikTok blocks */
    '.tt-inapp .shopify-payment-button, .tt-inapp shopify-accelerated-checkout, .tt-inapp shopify-accelerated-checkout-cart, .tt-inapp .additional-checkout-buttons { display: none !important; }',
    '.tt-inapp .buy-buttons--multiple { grid-template-columns: 1fr !important; }',
    /* TikTok's in-app browser cannot play background videos inline (play button, full screen): hide those sections */
    '.tt-inapp .shopify-section:has(cs-video[data-autoplay]), .tt-inapp [data-tt-hidden-video] { display: none !important; }',
    /* Vitals "Buy 2" bundle box: only on product pages, and only one (restarted Vitals can leave copies) */
    '.tt-inapp:not(.tt-pt-product) .vtl-ub-pb-main-widget, .tt-inapp .vtl-ub-pb-main-widget.tt-vtl-dup { display: none !important; }',
    '#tt-progress { position: fixed; top: 0; left: 0; height: 3px; width: 0; background: #e53935; z-index: 2147483646; transition: width .3s ease, opacity .3s ease; opacity: 0; pointer-events: none; }',
    '#tt-overlay { position: fixed; inset: 0; z-index: 2147483647; background: rgba(0,0,0,.72); display: flex; align-items: flex-end; justify-content: center; font-family: inherit; }',
    '#tt-overlay .tt-sheet { background: #fff; color: #111; width: 100%; max-width: 520px; border-radius: 18px 18px 0 0; padding: 22px 20px calc(22px + env(safe-area-inset-bottom)); box-shadow: 0 -8px 30px rgba(0,0,0,.25); }',
    '#tt-overlay h3 { margin: 0 0 6px; font-size: 20px; font-weight: 800; letter-spacing: .2px; text-transform: none; color: #111; }',
    '#tt-overlay p { margin: 0 0 14px; font-size: 14px; line-height: 1.45; color: #333; }',
    '#tt-overlay ol { margin: 0 0 16px; padding-left: 20px; font-size: 15px; line-height: 1.55; color: #111; }',
    '#tt-overlay ol b { font-weight: 800; }',
    '#tt-overlay .tt-dots { display: inline-block; background: #111; color: #fff; border-radius: 6px; padding: 0 7px; font-weight: 800; letter-spacing: 1px; }',
    '#tt-overlay .tt-arrow { position: fixed; top: 10px; right: 14px; color: #fff; font-size: 13px; font-weight: 800; text-align: right; line-height: 1.2; text-shadow: 0 1px 3px rgba(0,0,0,.6); }',
    '#tt-overlay .tt-arrow span { display: block; font-size: 30px; line-height: 1; }',
    '#tt-overlay .tt-btn { display: block; width: 100%; border: 0; border-radius: 10px; padding: 15px; font-size: 16px; font-weight: 800; cursor: pointer; margin-top: 8px; }',
    '#tt-overlay .tt-btn--primary { background: #111; color: #fff; }',
    '#tt-overlay .tt-btn--ghost { background: #f1f1f1; color: #111; }',
    '#tt-overlay .tt-link { word-break: break-all; font-size: 12px; color: #666; background: #f6f6f6; border-radius: 8px; padding: 8px 10px; margin: 0 0 6px; }',
    '#tt-overlay .tt-ok { color: #1b8a3a; font-weight: 700; font-size: 13px; min-height: 18px; margin-top: 6px; text-align: center; }'
  ].join('\n');
  var styleEl = document.createElement('style');
  styleEl.id = 'tt-inapp-style';
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  function hideVideoSections(root) {
    try {
      (root || document).querySelectorAll('cs-video[data-autoplay]').forEach(function (vm) {
        var sec = vm.closest('.shopify-section') || vm;
        sec.setAttribute('data-tt-hidden-video', '');
        var v = vm.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} v.removeAttribute('autoplay'); }
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { hideVideoSections(document); });
  else hideVideoSections(document);

  /* ---------- helpers ---------- */
  var progress;
  function showProgress() {
    if (!progress) {
      progress = document.createElement('div');
      progress.id = 'tt-progress';
      document.body.appendChild(progress);
    }
    progress.style.opacity = '1';
    progress.style.width = '35%';
    setTimeout(function () { if (progress.style.opacity === '1') progress.style.width = '75%'; }, 350);
  }
  function hideProgress() {
    if (!progress) return;
    progress.style.width = '100%';
    setTimeout(function () { progress.style.opacity = '0'; progress.style.width = '0'; }, 250);
  }

  // Paths that must never be loaded inside the page
  function isBlockedPath(path) {
    return /^\/(checkout|checkouts|account|apps|cart\/\d|cart\/c\/|tools|admin|services|wpm|web-pixels|cdn|password|challenge)/.test(path);
  }
  function isCheckoutPath(path) {
    return /^\/(checkout|checkouts|cart\/\d|cart\/c\/)/.test(path);
  }

  // Page paths we load in place
  function isSoftPath(path) {
    if (isBlockedPath(path)) return false;
    return path === '/' || /^\/(collections|products|pages|search|blogs|policies|cart)(\/|$|\?)/.test(path) ||
      /^\/[a-z]{2}(-[a-z]{2})?\/(collections|products|pages|search|blogs|policies|cart)(\/|$)/.test(path) ||
      /^\/[a-z]{2}(-[a-z]{2})?\/?$/.test(path);
  }

  function closeOpenDrawers() {
    try {
      document.querySelectorAll('dialog[open], details[open][data-menu-disclosure], .popover[open]').forEach(function (el) {
        if (el.id === 'tt-overlay') return;
        if (typeof el.hide === 'function') { try { el.hide(); return; } catch (e) {} }
        if (typeof el.close === 'function' && el.tagName === 'DIALOG') { try { el.close(); return; } catch (e) {} }
        el.removeAttribute('open');
      });
      document.body.classList.remove('Vtl-Modal--Active');
      document.body.classList.remove('is-locked');
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
    } catch (e) {}
  }

  function runScripts(container) {
    container.querySelectorAll('script').forEach(function (old) {
      var type = (old.getAttribute('type') || '').toLowerCase();
      if (type && type !== 'text/javascript' && type !== 'module' && type !== 'application/javascript') return; // JSON etc. stay as data
      var src = old.getAttribute('src');
      if (src) {
        // external script already loaded on this page: do not load/run it twice
        var already = Array.prototype.some.call(document.querySelectorAll('script[src]'), function (s) {
          return s !== old && !container.contains(s) && s.getAttribute('src') === src;
        });
        if (already) return;
      }
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      s.setAttribute('data-tt-cloned', '');
      if (!src) s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  function syncHead(newDoc) {
    // add stylesheets used by the new page that are not loaded yet
    newDoc.querySelectorAll('head link[rel="stylesheet"]').forEach(function (l) {
      var href = l.getAttribute('href');
      if (href && !document.querySelector('head link[rel="stylesheet"][href="' + href + '"]')) {
        document.head.appendChild(l.cloneNode(true));
      }
    });
    // meta description / canonical
    ['meta[name="description"]', 'link[rel="canonical"]', 'meta[property="og:title"]', 'meta[property="og:url"]'].forEach(function (sel) {
      var n = newDoc.querySelector(sel), o = document.querySelector(sel);
      if (n && o) o.replaceWith(n.cloneNode(true));
    });
  }

  function swapSectionGroup(newDoc, cls) {
    var olds = document.querySelectorAll('.' + cls);
    var news = newDoc.querySelectorAll('.' + cls);
    if (!olds.length || olds.length !== news.length) return;
    olds.forEach(function (o, i) {
      var n = news[i];
      if (o.id && n.id && o.id === n.id && o.innerHTML !== n.innerHTML) {
        var clone = document.importNode(n, true);
        o.replaceWith(clone);
        runScripts(clone);
      }
    });
  }

  var navSeq = 0;
  function softNavigate(url, opts) {
    opts = opts || {};
    var seq = ++navSeq;
    closeOpenDrawers();
    showProgress();
    return fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (res) {
        var finalUrl = new URL(res.url || url, location.href);
        if (finalUrl.origin !== location.origin || isCheckoutPath(finalUrl.pathname)) {
          throw { ttCheckout: true, url: finalUrl.href };
        }
        var ct = res.headers.get('content-type') || '';
        if (!res.ok && res.status !== 404) throw new Error('HTTP ' + res.status);
        if (ct.indexOf('text/html') === -1) throw new Error('not html');
        return res.text().then(function (html) { return { html: html, url: finalUrl }; });
      })
      .then(function (r) {
        if (seq !== navSeq) return; // a newer navigation started
        var doc = new DOMParser().parseFromString(r.html, 'text/html');
        var newMain = doc.getElementById('main');
        var oldMain = document.getElementById('main');
        if (!newMain || !oldMain) throw new Error('no main');

        syncHead(doc);
        document.title = doc.title;
        if (doc.body && doc.body.className !== undefined) document.body.className = doc.body.className;
        swapSectionGroup(doc, 'shopify-section-group-header-group');

        var fresh = document.importNode(newMain, true);
        hideVideoSections(fresh);
        oldMain.replaceWith(fresh);
        runScripts(fresh);

        var target = r.url.pathname + r.url.search + (new URL(url, location.href).hash || '');
        if (opts.replace) history.replaceState({ tt: true }, '', target);
        else if (!opts.fromPop) history.pushState({ tt: true }, '', target);

        var hash = new URL(url, location.href).hash;
        if (hash && document.getElementById(hash.slice(1))) {
          document.getElementById(hash.slice(1)).scrollIntoView();
        } else if (!opts.fromPop) {
          window.scrollTo(0, 0);
        }
        hideProgress();
        document.dispatchEvent(new CustomEvent('tt:navigated', { detail: { url: target } }));
        refreshApps();
        refreshVitals(doc);
      })
      .catch(function (err) {
        hideProgress();
        if (err && err.ttCheckout) { if (window.__ttCheckoutDirect) { location.href = err.url; return; } openCheckoutSheet(); return; }
        // Could not load in place: explain instead of letting TikTok show its block screen
        openBrowserSheet(url);
      });
  }

  // Vitals (reviews, stars, bundles, trust badges) draws its widgets once per page load, from
  // data in scripts outside #main. After loading a page in place: take that page's Vitals data
  // and run Vitals again. window.instantClick is Vitals' own switch for sites that load pages
  // in place (InstantClick support): with it, Vitals starts again instead of skipping.
  // Page type class on <html> (tt-pt-product, tt-pt-collection, ...)
  function setPageType(pt) {
    var h = document.documentElement;
    h.className = h.className.replace(/(^|\s)tt-pt-\S+/g, ' ').trim();
    if (pt) h.classList.add('tt-pt-' + String(pt).toLowerCase());
  }
  try { setPageType(window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.pageType); } catch (e) {}

  // Keep one filled bundle box; hide empty or extra copies left by an earlier Vitals run
  function dedupeVitals() {
    try {
      var w = Array.prototype.slice.call(document.querySelectorAll('.vtl-ub-pb-main-widget'));
      var keep = null;
      w.forEach(function (x) {
        var filled = (x.innerText || '').replace(/\s+/g, '').length > 0;
        if (filled && !keep) { keep = x; x.classList.remove('tt-vtl-dup'); }
        else x.classList.add('tt-vtl-dup');
      });
    } catch (e) {}
  }
  function dedupeSoon() {
    [500, 1500, 3000, 6000, 10000].forEach(function (t) { setTimeout(dedupeVitals, t); });
  }

  // A restarted Vitals registers its custom elements again: skip names that already exist
  try {
    if (window.customElements && !customElements.__ttSafe) {
      var origDefine = customElements.define.bind(customElements);
      customElements.define = function (name) {
        if (customElements.get(name)) return;
        return origDefine.apply(null, arguments);
      };
      customElements.__ttSafe = true;
    }
  } catch (e) {}

  var vitalsRun = 0;
  function refreshVitals(doc) {
    try {
      var bundle = doc.getElementById('vtlsAebBundle');
      if (!bundle || !doc.getElementById('vtlsAebData')) return;
      // Shopify's page info for the new page (Vitals reads the page type and product from it)
      doc.querySelectorAll('script:not([src])').forEach(function (sc) {
        var t = sc.textContent || '';
        var i = t.indexOf('var meta = {');
        if (i > -1 && t.indexOf('ShopifyAnalytics.meta') > -1) {
          try {
            var m = JSON.parse(t.slice(i + 11, t.lastIndexOf(';', t.indexOf('for (var attr in meta)'))));
            var sa = window.ShopifyAnalytics = window.ShopifyAnalytics || {};
            var cur = sa.meta && sa.meta.currency;
            sa.meta = { currency: cur };
            for (var k in m) sa.meta[k] = m[k];
            window.meta = m;
            setPageType(m.page && m.page.pageType);
          } catch (e) {}
        }
        var j = t.indexOf('var __st=');
        if (j > -1) { try { window.__st = JSON.parse(t.slice(j + 9, t.indexOf(';', j))); } catch (e) {} }
      });
      // let Vitals start again (its own support for sites that load pages in place)
      if (window.instantClick === undefined && window.InstantClick === undefined) window.instantClick = { ttInapp: true };
      ['vitals-styles', 'vitals-integration-styles'].forEach(function (id) { var e = document.getElementById(id); if (e) e.remove(); });
      document.body.removeAttribute('data-vitals_embedded');
      window.vtlsLiquidData = {};
      ['vtlsAebData', 'vtlsAebDynamicFunctions', 'vtlsAebDocumentInjectors'].forEach(function (id) {
        var n = doc.getElementById(id);
        if (!n) return;
        var sc = document.createElement('script');
        sc.textContent = n.textContent;
        document.body.appendChild(sc);
        sc.remove();
      });
      var ld = doc.getElementById('vtlsAebReviewsSchemaJson'), oldLd = document.getElementById('vtlsAebReviewsSchemaJson');
      if (oldLd) oldLd.remove();
      if (ld) document.head.appendChild(ld.cloneNode(true));
      var prev = document.querySelector('script[data-tt-vitals-bundle]');
      if (prev) prev.remove();
      var b = document.createElement('script');
      b.src = bundle.getAttribute('src');
      b.async = true;
      b.setAttribute('data-tt-vitals-bundle', String(++vitalsRun));
      document.body.appendChild(b);
      dedupeSoon();
    } catch (e) {}
  }

  // Let layout-dependent widgets (sliders, sticky bars) re-measure
  function refreshApps() {
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }

  /* ---------- link clicks ---------- */
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    if (a.closest('#tt-overlay')) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download') || a.hasAttribute('aria-controls') || a.getAttribute('role') === 'button') return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|sms:|javascript:)/i.test(href)) return;
    var u;
    try { u = new URL(href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return; // external links: TikTok decides
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return; // same page anchor
    if (isCheckoutPath(u.pathname)) { if (window.__ttCheckoutDirect) return; e.preventDefault(); openCheckoutSheet(); return; }
    if (!isSoftPath(u.pathname)) return;
    e.preventDefault();
    softNavigate(u.href);
  });

  window.addEventListener('popstate', function () {
    softNavigate(location.href, { fromPop: true });
  });

  /* ---------- forms ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || location.pathname;
    var u;
    try { u = new URL(action, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    var submitter = e.submitter;
    var goesToCheckout = isCheckoutPath(u.pathname) ||
      (submitter && submitter.name === 'checkout') ||
      (/^\/cart\/?$/.test(u.pathname) && (form.querySelector('[name="checkout"]') && (!submitter || submitter.name === 'checkout')));
    if (goesToCheckout && window.__ttCheckoutDirect) return; // TEST: let checkout load normally
    if (goesToCheckout) {
      e.preventDefault();
      e.stopImmediatePropagation();
      // save a changed cart note / quantities first, then show the sheet
      var fd = new FormData(form);
      fd.delete('checkout');
      fetch('/cart/update.js', { method: 'POST', body: fd, credentials: 'same-origin' })
        .catch(function () {})
        .then(openCheckoutSheet);
      return;
    }
    // search and other GET forms: load in place
    if ((form.method || 'get').toLowerCase() === 'get' && isSoftPath(u.pathname) && !e.defaultPrevented) {
      e.preventDefault();
      var params = new URLSearchParams(new FormData(form));
      u.search = params.toString();
      softNavigate(u.href);
    }
  }, true);

  /* ---------- checkout sheet ---------- */
  var savedUrl = null;
  function closeSheet() {
    var o = document.getElementById('tt-overlay');
    if (o) o.remove();
    if (savedUrl) { try { history.replaceState({ tt: true }, '', savedUrl); } catch (e) {} savedUrl = null; }
  }

  function copyText(text, okEl) {
    function done() { if (okEl) okEl.textContent = 'Link copied ✓'; }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.top = '-1000px';
      document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, text.length);
      try { document.execCommand('copy'); done(); } catch (e) { if (okEl) okEl.textContent = 'Press and hold the link above to copy it'; }
      ta.remove();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, fallback);
    } else { fallback(); }
  }

  function sheet(title, intro, link, primaryLabel) {
    var existing = document.getElementById('tt-overlay');
    if (existing) existing.remove(); // replace the sheet but keep the cart-link address
    var o = document.createElement('div');
    o.id = 'tt-overlay';
    o.setAttribute('role', 'dialog');
    o.setAttribute('aria-modal', 'true');
    o.innerHTML =
      '<div class="tt-arrow">Tap here<span>↗</span></div>' +
      '<div class="tt-sheet">' +
        '<h3></h3><p class="tt-intro"></p>' +
        '<ol>' +
          '<li>Tap <span class="tt-dots">•••</span> in the <b>top right corner</b></li>' +
          '<li>Choose <b>“Open in browser”</b></li>' +
          '<li class="tt-step3"></li>' +
        '</ol>' +
        '<div class="tt-link"></div>' +
        '<button type="button" class="tt-btn tt-btn--primary tt-copy"></button>' +
        '<button type="button" class="tt-btn tt-btn--ghost tt-close">Keep browsing</button>' +
        '<div class="tt-ok"></div>' +
      '</div>';
    o.querySelector('h3').textContent = title;
    o.querySelector('.tt-intro').textContent = intro;
    o.querySelector('.tt-step3').innerHTML = link.step3;
    o.querySelector('.tt-link').textContent = link.url;
    o.querySelector('.tt-copy').textContent = primaryLabel;
    o.querySelector('.tt-copy').addEventListener('click', function () { copyText(link.url, o.querySelector('.tt-ok')); });
    o.querySelector('.tt-close').addEventListener('click', closeSheet);
    o.addEventListener('click', function (e) { if (e.target === o) closeSheet(); });
    document.body.appendChild(o);
    // app pop-ups (e.g. Vitals upsell) can still be open in the browser's top layer: close them
    try { document.querySelectorAll('dialog[open]').forEach(function (d) { if (d.close) d.close(); }); } catch (e) {}
  }

  function openHandoffSheet() {
    closeOpenDrawers();
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) { softNavigate('/cart'); return; }
        var parts = cart.items.map(function (it) { return it.variant_id + ':' + it.quantity; });
        var permalink = location.origin + '/cart/' + parts.join(',');
        var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        if (codes.length) permalink += '?discount=' + encodeURIComponent(codes[0]);
        // Make "Open in browser" open this cart link directly
        if (savedUrl === null) savedUrl = location.pathname + location.search + location.hash;
        try { history.replaceState({ tt: true }, '', permalink.replace(location.origin, '')); } catch (e) {}
        sheet(
          'Almost done – finish in your browser 🔒',
          'TikTok doesn’t allow payments inside the app. Your cart (' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ') comes with you:',
          { url: permalink, step3: 'Your cart opens <b>straight at checkout</b>. If not, paste the copied link.' },
          'Copy my cart link'
        );
      })
      .catch(function () { openBrowserSheet(location.origin + '/cart'); });
  }


  /* ---------- in-app checkout (TEST) ----------
   * TikTok cancels every full-page navigation after the first page, but it does allow
   * embedded frames. Shopify's checkout allows being framed by its own domain
   * (frame-ancestors 'self'), so inside TikTok the real Shopify checkout opens as a
   * full-screen panel over the current page. If anything goes wrong, the "Open in browser"
   * hand-off sheet is shown instead. Disable with ?tt_frame=0 (re-enable with ?tt_frame=1).
   */
  var inAppCheckout = (function () {
    if (window.__TT_INAPP_CHECKOUT === false) return false;
    try {
      var q = new URLSearchParams(location.search);
      if (q.get('tt_frame') === '0') sessionStorage.setItem('tt_frame', '0');
      if (q.get('tt_frame') === '1') sessionStorage.removeItem('tt_frame');
      return sessionStorage.getItem('tt_frame') !== '0';
    } catch (e) { return true; }
  })();

  var frameCss = [
    '#tt-checkout { position: fixed; inset: 0; z-index: 2147483647; background: #fff; display: flex; flex-direction: column; }',
    '#tt-checkout .tt-ck-bar { flex: 0 0 auto; display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; padding-top: calc(10px + env(safe-area-inset-top)); background: #000; color: #fff; font-family: inherit; }',
    '#tt-checkout .tt-ck-title { font-size: 15px; font-weight: 800; letter-spacing: .3px; }',
    '#tt-checkout .tt-ck-close { background: transparent; border: 0; color: #fff; font-size: 26px; line-height: 1; padding: 2px 6px; cursor: pointer; }',
    '#tt-checkout iframe { flex: 1 1 auto; width: 100%; border: 0; background: #fff; }',
    '#tt-checkout .tt-ck-help { flex: 0 0 auto; text-align: center; font-size: 12px; padding: 8px 12px calc(8px + env(safe-area-inset-bottom)); background: #f6f6f6; color: #444; }',
    '#tt-checkout .tt-ck-help a { color: #111; text-decoration: underline; cursor: pointer; }',
    '#tt-checkout .tt-ck-loading { position: absolute; left: 0; right: 0; top: 60px; text-align: center; font-size: 14px; color: #666; pointer-events: none; }'
  ].join('\n');
  var frameStyle = document.createElement('style');
  frameStyle.textContent = frameCss;
  document.head.appendChild(frameStyle);

  var framePoll = null, frameTimeout = null, frameDone = false, frameWasOnCheckout = false;
  function closeCheckoutFrame(goHome) {
    var o = document.getElementById('tt-checkout');
    if (o) o.remove();
    if (framePoll) { clearInterval(framePoll); framePoll = null; }
    if (frameTimeout) { clearTimeout(frameTimeout); frameTimeout = null; }
    document.documentElement.style.removeProperty('overflow');
    if (savedUrl) { try { history.replaceState({ tt: true }, '', savedUrl); } catch (e) {} savedUrl = null; }
    if (goHome) softNavigate('/');
  }
  function frameFallback() {
    closeCheckoutFrame(false);
    openHandoffSheet();
  }

  function openCheckoutFrame() {
    closeOpenDrawers();
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) { softNavigate('/cart'); return; }
        // Backup: "••• → Open in browser" still lands in checkout with the same cart
        var parts = cart.items.map(function (it) { return it.variant_id + ':' + it.quantity; });
        if (savedUrl === null) savedUrl = location.pathname + location.search + location.hash;
        try { history.replaceState({ tt: true }, '', '/cart/' + parts.join(',')); } catch (e) {}

        var existing = document.getElementById('tt-checkout');
        if (existing) existing.remove();
        frameDone = false; frameWasOnCheckout = false;
        var o = document.createElement('div');
        o.id = 'tt-checkout';
        o.innerHTML =
          '<div class="tt-ck-bar"><span class="tt-ck-title">🔒 Secure checkout</span><button type="button" class="tt-ck-close" aria-label="Close">×</button></div>' +
          '<div class="tt-ck-loading">Loading secure checkout…</div>' +
          '<iframe title="Checkout" allow="payment *; clipboard-write" referrerpolicy="strict-origin-when-cross-origin"></iframe>' +
          '<div class="tt-ck-help">Problems paying? <a class="tt-ck-browser">Open checkout in your browser</a></div>';
        var f = o.querySelector('iframe');
        o.querySelector('.tt-ck-close').addEventListener('click', function () { closeCheckoutFrame(frameDone); });
        o.querySelector('.tt-ck-browser').addEventListener('click', frameFallback);
        document.body.appendChild(o);
        document.documentElement.style.overflow = 'hidden';
        try { document.querySelectorAll('dialog[open]').forEach(function (d) { if (d.close) d.close(); }); } catch (e) {}

        f.addEventListener('load', function () {
          var l = o.querySelector('.tt-ck-loading'); if (l) l.remove();
        });
        f.src = '/checkout?skip_shop_pay=true';

        // Not on the checkout after 20 s -> fall back to the browser hand-off
        frameTimeout = setTimeout(function () { if (!frameWasOnCheckout) frameFallback(); }, 20000);

        // Watch where the frame is: checkout / thank-you page / left the checkout
        framePoll = setInterval(function () {
          if (!document.getElementById('tt-checkout')) { clearInterval(framePoll); framePoll = null; return; }
          var path = null;
          try { path = f.contentWindow.location.pathname; } catch (e) { path = null; }
          if (path === null || path === 'blank') {
            // unreadable = another domain (e.g. a payment page that can't be framed) or a blocked page
            if (frameWasOnCheckout && !frameDone) frameFallback();
            return;
          }
          if (/\/(thank[-_]you|thank_you|orders\/)/.test(path) || /thank/i.test(path)) {
            if (!frameDone) {
              frameDone = true;
              var t = o.querySelector('.tt-ck-title'); if (t) t.textContent = '✓ Order confirmed';
              var h = o.querySelector('.tt-ck-help'); if (h) h.remove();
            }
            return;
          }
          if (/^\/(checkouts|checkout)(\/|$)/.test(path)) { frameWasOnCheckout = true; return; }
          if (path && path !== '/' + '' && frameWasOnCheckout && !frameDone) {
            // the buyer tapped a store link inside the checkout (logo, "return to cart"): close and show it in place
            closeCheckoutFrame(false);
            softNavigate(path);
          }
        }, 800);
      })
      .catch(function () { openHandoffSheet(); });
  }

  function openCheckoutSheet() {
    if (inAppCheckout) openCheckoutFrame(); else openHandoffSheet();
  }

  function openBrowserSheet(url) {
    var full = new URL(url, location.href).href;
    if (savedUrl === null) savedUrl = location.pathname + location.search + location.hash;
    try { if (new URL(full).origin === location.origin) history.replaceState({ tt: true }, '', full.replace(location.origin, '')); } catch (e) {}
    sheet(
      'Open in your browser',
      'TikTok can’t open this page inside the app.',
      { url: full, step3: 'The page opens in your browser.' },
      'Copy link'
    );
  }

  var checkoutTapFn = function () {};
  if (!window.__ttCheckoutDirect) {
  // Checkout buttons ("Checkout" in the cart, "Buy it now", express buttons, checkout links):
  // caught at the very first moment of the tap, before the theme can navigate.
  checkoutTapFn = function (e) { return onCheckoutTap(e); };
  function onCheckoutTap(e) {
    var b = e.target && e.target.closest && e.target.closest('.tt-checkout, [name="checkout"], .shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, a[href*="/checkout"], .Vtl-CheckoutClickModal__AcceptButton');
    if (!b || (b.closest && b.closest('#tt-overlay'))) return;
    if (e.cancelable) e.preventDefault();
    e.stopImmediatePropagation();
    var form = b.form || (b.closest && b.closest('form'));
    if (form && form.querySelector('[name="note"], [name^="updates"]')) {
      var fd = new FormData(form);
      fd.delete('checkout');
      fetch('/cart/update.js', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {}).then(openCheckoutSheet);
    } else {
      openCheckoutSheet();
    }
  }
  // The early guard in <head> (snippets/tt-inapp-guard.liquid) catches the tap before any app
  // and calls ttInapp.checkoutTap. Without the guard, listen here.
  if (!window.__ttEarly) window.addEventListener('click', onCheckoutTap, true);

  // Turn every checkout button into our own button: no form submit, and other apps
  // (e.g. the Vitals checkout upsell) no longer recognise it and cannot navigate away.
  function neutralizeCheckoutButtons(root) {
    try {
      (root || document).querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(function (btn) {
        btn.removeAttribute('name');
        btn.setAttribute('type', 'button');
        btn.classList.add('tt-checkout');
      });
    } catch (e) {}
  }
  neutralizeCheckoutButtons(document);

  // The Vitals checkout upsell pop-up can never complete inside TikTok (its "Check out"
  // loads the checkout page, which TikTok blocks) and it covers our sheet: close it at once.
  function closeCheckoutPopups() {
    try {
      document.querySelectorAll('dialog.Vtl-CheckoutClickModal[open], .vtl-checkout-click-popup-root dialog[open]').forEach(function (d) {
        try { d.close(); } catch (e) { d.removeAttribute('open'); }
      });
      document.body && document.body.classList.remove('Vtl-Modal--Active');
    } catch (e) {}
  }
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.nodeType === 1 && (t.matches('dialog.Vtl-CheckoutClickModal') || (t.querySelector && t.querySelector('dialog.Vtl-CheckoutClickModal[open]')))) { closeCheckoutPopups(); return; }
      }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['open', 'class'], childList: true, subtree: true });
  } catch (e) {}
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1) neutralizeCheckoutButtons(n.parentNode || n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  // Last safety net: a script calling form.submit() / requestSubmit() on a checkout form
  try {
    var isCheckoutForm = function (f) {
      try {
        var u = new URL(f.getAttribute('action') || location.pathname, location.href);
        return u.origin === location.origin && (isCheckoutPath(u.pathname) || (/^\/cart\/?$/.test(u.pathname) && !!f.querySelector('[name="checkout"]')));
      } catch (e) { return false; }
    };
    var origSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (isCheckoutForm(this)) { openCheckoutSheet(); return; }
      return origSubmit.apply(this, arguments);
    };
    if (HTMLFormElement.prototype.requestSubmit) {
      var origReq = HTMLFormElement.prototype.requestSubmit;
      HTMLFormElement.prototype.requestSubmit = function (sub) {
        if (isCheckoutForm(this) && (!sub || sub.name === 'checkout')) { openCheckoutSheet(); return; }
        return origReq.apply(this, arguments);
      };
    }
  } catch (e) {}

  } // end: checkout hand-off (skipped with ?tt_checkout=direct)

  window.ttInapp = { navigate: softNavigate, checkout: openCheckoutSheet, handoff: openHandoffSheet, checkoutTap: function (e) { return checkoutTapFn(e); }, version: '1.8.3-vitals' };
  if (window.__ttPendingCheckout) { window.__ttPendingCheckout = false; openCheckoutSheet(); }
})();
